import { graphql } from '../../../graphql/generated';

export const SPECIMENS_QUERY = graphql(`
  query Specimens($labId: ID!) {
    labSpecimens(labId: $labId) {
      id
      name
      storagePeriod
      classification
      features
      group
      requiresLocalizations
      localizationInputEnabled
      predefinedLocalizations
      localizationFields {
        label
        inputType
        unit
        mandatory
      }
      analysisStations {
        id
        name
      }
      testTubes {
        id
        name
        supplier
        color
      }
      forms {
        id
        name
      }
    }

    labAnalysisStations(labId: $labId) {
      id
      name
    }

    labTestTubes(labId: $labId) {
      id
      name
      supplier
      color
    }

    labForms(labId: $labId) {
      id
      name
    }
  }
`);
